module.exports = "<div class=\"container text-center\">\n  <div claSS=\"row\">\n\n\n\n    <div class=\"col-md-12\" style=\"text-align: center\">\n\n\n        <div>  <h2>something went Wrong !</h2></div>\n        <div>  <h2>Try After Some Time Or Login Again</h2></div>\n        <div>  <h2>Internal Server Error</h2></div>\n\n        <input type=\"button\" class=\"btn btn-info btn-md\" value=\"login\"  (click)=\"logout()\" />\n\n    </div>\n\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/error/error.component.html
// module id = ../../../../../src/app/error/error.component.html
// module chunks = main